import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const Home = () => import("@/components/home") //主页
const Index = () => import("@/components/index") //首页
const List = () => import("@/components/base/list") //列表
const Detail = () => import("@/components/base/detail") //详情
const scheduleList = () => import("@/components/base/scheduleList") //日程二级页

const routes = [
  {
    path: '/',
    component: Home,
    redirect: '/index',
    children: [
      { path: '/index', component: Index },
      { path: '/list', component: List },
      { path: '/detail', component: Detail },
      { path: '/scheduleList', component: scheduleList },
    ]
  },
]

const router = new VueRouter({
  routes
})
export default router